import { ReviewStageDataFieldTypeEnum } from '../../schemas';
import { DropdownForm } from '../Dropdown/DropdownForm';
import { MultipleChoiceForm } from '../MultipleChoice/MultipleChoiceForm';
import { TextFieldForm } from '../TextField/TextFieldForm';

export const DATA_FIELD_TYPE_TO_FORM: Record<
  keyof typeof ReviewStageDataFieldTypeEnum,
  () => JSX.Element | null
> = {
  text_field: TextFieldForm,
  datepicker: () => null,
  radio: MultipleChoiceForm,
  dropdown: DropdownForm,
};
